import { useApiClient } from '@/hooks/useApiClient'
import { useMemo } from 'react'
import { ConflictDependentSelect, type ConflictSelectProps } from './ConflictDependentSelect'

export function ScheduleItemTrailerSelect(props: ConflictSelectProps) {
  const api = useApiClient()
  const { data, isLoading } = api.useQuery('post', '/trailer/all')
  const trailers = useMemo(() => data?.map((x) => ({ id: x.id, name: x.trailer_number, depot: x.depot })) ?? [], [data])
  return (
    <ConflictDependentSelect label='Trailer' {...props} items={trailers} loading={isLoading} itemKey='trailer_id' />
  )
}
